import { VestingGraphData } from '../../../../../hooks/vesting-task/use-vesting-graph';
import { sharePlanVestingTypeTitle } from '../../../../../types/pool-plans.types';
import { DateFormatter, VestingGraphSubtitlePart } from './vesting-graph.types';

export const formatShortGrantId = (grantId: string) =>
  grantId.split('-')[0]?.toUpperCase() ?? grantId;

export const formatVestingCalendarDate = (
  format: DateFormatter,
  date: Date | string,
  pattern = 'dd/MM/yyyy',
) => {
  const parsed = new Date(date);
  const utcCalendarDay = new Date(
    parsed.getUTCFullYear(),
    parsed.getUTCMonth(),
    parsed.getUTCDate(),
  );

  return format(utcCalendarDay, pattern);
};

export const buildVestingGraphSubtitleParts = (
  vestingGraph: VestingGraphData,
): VestingGraphSubtitlePart[] => {
  const vestingTypeTitle = sharePlanVestingTypeTitle[vestingGraph.vestingType];
  const parts: VestingGraphSubtitlePart[] = [
    {
      id: 'VESTING_GRAPH_SUBTITLE',
      values: { vestingType: `${vestingTypeTitle.name} ${vestingTypeTitle.description}` },
    },
  ];

  if (vestingGraph.cliff && vestingGraph.cliff.months > 0) {
    parts.push({
      id: 'VESTING_GRAPH_SUBTITLE_CLIFF',
      values: { cliffMonths: vestingGraph.cliff.months },
    });
  }

  return parts;
};
